import React from 'react';

import ContentDetails, { ChangeDirection } from './ContentDetails';
import YearSelect from './YearSelect';
import {
  OurHistoryFragmentFragment,
  OurHistoryTimelineFragmentFragment,
} from '../../__generated__/graphql';
import Section from '../../layout/Section';
import SectionTitle from '../../layout/Section/SectionTitle';
import { ContentBlock } from '../types';

import style from './our-history.module.css';

const OurHistory: ContentBlock<OurHistoryFragmentFragment> = ({ fragment }) => {
  const contentBlockProps = fragment.ourHistory;

  const [changeDirection, setChangeDirection] = React.useState<ChangeDirection>(null);
  const [selectedIndex, setSelectedIndex] = React.useState(0);

  if (!contentBlockProps) {
    return null;
  }

  const handleSetSelectedIndex = (index: number) => {
    if (index === selectedIndex) {
      return;
    }

    setChangeDirection(index > selectedIndex ? 'future' : 'past');
    setSelectedIndex(index);
  };

  return (
    <Section
      backgroundColor="black"
      id={contentBlockProps.sectionId}
      innerContainerClassName={style.ourHistory}
    >
      <SectionTitle>
        {contentBlockProps.title}
      </SectionTitle>

      <YearSelect
        onChangeSelectedIndex={handleSetSelectedIndex}
        selectedIndex={selectedIndex}
        years={(contentBlockProps.timeline ?? []).map(item => item?.year ?? 0)}
      />

      <ContentDetails
        changeDirection={changeDirection}
        selectedIndex={selectedIndex}
        timeline={contentBlockProps.timeline as OurHistoryTimelineFragmentFragment[]}
      />
    </Section>
  );
};

export default OurHistory;
